// extracted by mini-css-extract-plugin
module.exports = {"dialog--wrapper":"dialog--wrapper__kFxJk"};